import { ScopeableType } from '../../../types';
import { ScopeItem } from '../../form-fields/scope-selector/scope-selector-constants';

export type VbdLevel = 'partnership' | 'client';

export interface VbdTierFormValues {
  upperBound: number | null;
  discount: number | null;
  c1: number | null;
  c2: number | null;
  c3: number | null;
}

export interface VbdFormValues {
  level: VbdLevel;
  partnershipId: number | null;
  clientId: number | null;
  scopeableType: ScopeableType;
  scopes: ScopeItem[];
  startDate: string | null;
  endDate: string | null;
  suppressEmptyCharges: boolean;
  tiers: VbdTierFormValues[];
}

export interface VbdTierInput {
  tier: number;
  discount: number;
  subscriptionTier: { lower: number; upper: number | null };
  milestoneDiscount: { c1: number; c2: number; c3: number };
}

export interface ParsedVbdFormValues {
  level: VbdLevel;
  partnershipId: number | null;
  clientId: number | null;
  scopes: ScopeItem[];
  startDate: string;
  endDate: string | null;
  suppressEmptyCharges: boolean;
  vbdTiers: VbdTierInput[];
}

export const DEFAULT_VBD_FORM_VALUES: VbdFormValues = {
  level: 'partnership',
  partnershipId: null,
  clientId: null,
  scopeableType: ScopeableType.Global,
  scopes: [],
  startDate: null,
  endDate: null,
  suppressEmptyCharges: true,
  tiers: [
    { upperBound: 2000, discount: 0, c1: 32, c2: 34, c3: 34 },
    { upperBound: 3000, discount: 50, c1: 32, c2: 34, c3: 34 },
    { upperBound: null, discount: 100, c1: 32, c2: 34, c3: 34 },
  ],
};
